var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.9 6c0 3.315 2.73 6 6.1 6s6.1-2.685 6.1-6-2.73-6-6.1-6-6.1 2.685-6.1 6",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.033 22.013C2.97 17.442 7.076 14 12 14s9.03 3.442 9.967 8.013c.222 1.082-.71 1.987-1.833 1.987H3.866c-1.123 0-2.055-.904-1.833-1.987"
})));
export default SvgIcProfile;